import React, { useState } from "react";

const QuizQuestions = ({ questions, onComplete }) => {
  const [idx, setIdx] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [picked, setPicked] = useState(null);
  const [revealed, setRevealed] = useState(false);

  const q = questions[idx];
  const pct = ((idx + 1) / questions.length) * 100;
  const last = idx === questions.length - 1;

  const check = () => {
    if (!picked) return;
    setRevealed(true);
  };

  const next = () => {
    const updated = [...answers, picked.isCorrect];
    setAnswers(updated);
    if (last) {
      onComplete(updated);
    } else {
      setIdx(idx + 1);
      setPicked(null);
      setRevealed(false);
    }
  };

  return (
    <div className="panel">
      <div className="q-header">
        <span className="q-counter">{idx + 1}/{questions.length}</span>
        <div className="q-bar"><div className="q-bar-fill" style={{ width: `${pct}%` }} /></div>
      </div>

      <p className="q-text">{q.question}</p>

      <div className="q-options">
        {q.options.map((o, i) => {
          const letter = String.fromCharCode(65 + i);
          let state = "";
          if (picked === o) state = "picked";
          if (revealed && o.isCorrect) state = "correct";
          if (revealed && picked === o && !o.isCorrect) state = "wrong";

          return (
            <button
              key={i}
              className={`q-opt ${state}`}
              onClick={() => !revealed && setPicked(o)}
              disabled={revealed}
            >
              <span className="q-opt-letter">{letter}</span>
              <span className="q-opt-text">{o.text}</span>
            </button>
          );
        })}
      </div>

      {revealed && (
        <div className={`q-feedback ${picked?.isCorrect ? 'q-fb-ok' : 'q-fb-no'}`}>
          {picked?.isCorrect ? "Dogru cevap!" : "Yanlis cevap!"}
        </div>
      )}

      {!revealed ? (
        <button className="btn" onClick={check} disabled={!picked}>Kontrol Et</button>
      ) : (
        <button className="btn" onClick={next}>{last ? "Sonuclari Gor" : "Siradaki Soru"}</button>
      )}
    </div>
  );
};

export default QuizQuestions;
